/* ──────────────────────────────────────────────────────────────────────────
   vfs-colour-base.js — decides whether a chosen colour needs the light (W05)
   or the dark (N00) tinting base, so the paint's price group can follow the
   colour automatically.

   Why a formula and not a table: the colour database holds ~29,800 colours
   across ~151 waaiers and has no base field. Verfsale's supplier list covers
   only the 191 RAL colours. That list was used to calibrate the rule below,
   which reproduces it for 180 of 182 unambiguous colours (98.9%) — so every
   other waaier, and any colour added later, classifies itself with no data
   to ship or maintain.

   Overrides: window.VFS_BASE_OVERRIDES maps a colour id or an upper-cased
   colour name to 'licht' | 'donker'. Verfsale maintain it themselves in the
   Shopify admin; it is rendered into the page by snippets/vfs-colour-base.liquid.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var L_HI = 87.0; //  L* at or above this is always the light base
  var S_MAX = 34.0; //  ...below this saturation, a mid-light colour is still light
  var L_LO = 57.5; //  ...provided L* is at least this

  /* CIE L* (perceptual lightness) and HSV saturation from #rrggbb. */
  function features(hex) {
    var h = String(hex || '').trim().replace(/^#/, '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;

    var r = parseInt(h.slice(0, 2), 16) / 255;
    var g = parseInt(h.slice(2, 4), 16) / 255;
    var b = parseInt(h.slice(4, 6), 16) / 255;

    function lin(c) {
      return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }
    var Y = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
    var L = Y > 0.008856 ? 116 * Math.pow(Y, 1 / 3) - 16 : 903.3 * Y;

    var mx = Math.max(r, g, b);
    var mn = Math.min(r, g, b);
    var S = mx === 0 ? 0 : ((mx - mn) / mx) * 100;

    return { L: L, S: S };
  }

  /* 'licht' | 'donker' | null (null = hex unusable, caller should not guess) */
  function baseFor(colour) {
    if (!colour) return null;

    var overrides = window.VFS_BASE_OVERRIDES || {};
    var byId = colour.id != null ? overrides[String(colour.id)] : null;
    if (byId === 'licht' || byId === 'donker') return byId;

    var name = (colour.name || '').trim().toUpperCase();
    if (name && (overrides[name] === 'licht' || overrides[name] === 'donker')) {
      return overrides[name];
    }

    var f = features(colour.hex);
    if (!f) return null;
    return f.L >= L_HI || (f.S <= S_MAX && f.L >= L_LO) ? 'licht' : 'donker';
  }

  window.vfsColourBase = { baseFor: baseFor, features: features };
})();
